module.exports = __webpack_public_path__ + "static/media/icn_policy_found_f.0bf9be19.svg";